import { h } from 'vue'
import { RouterView } from 'vue-router'
import __C from '../primitives/_constant_'
import { ServiceRoutes } from '../router/service'

export default {
  methods: {
    setServiceRouter(navItems) {
      ServiceRoutes(navItems, _routes__ => {
        // addRoutes merges new routes added to existing routes, and
        // replace old one to new one if found same routes with...
        // "children: rRoutes" means that rRoutes is added to
        // existing routes, not removing or replacing the existings.
        let rootRoutes = this.$router.getRoutes().find(route => route.path == '/')
        let serviceRoutes = {
          path: 'service',
          redirect: __C.APPLICATION.URL_HOME,
          name: 'Application Service Page',
          // component: { render () { return h('router-view') }},
          component: RouterView,
          children: _routes__
        }
        if (rootRoutes) {
          //rootRoutes.children = [serviceRoutes] // This is wrong. It replaces the existing children.
          //rootRoutes.children.push(serviceRoutes) // This is correct. It adds new children to the existing children.
          if (!rootRoutes.children.some(route => route.path === 'service')) {
            rootRoutes.children.push(serviceRoutes);
          }
        } else {
          rootRoutes = {
            path: '/',
            // component: { render: () => h('router-view') },
            component: RouterView,
            children: [serviceRoutes]
          }
        }
        // "addRoutes" adds new routes to the root routes. It doesn't find
        // child node, doesn't add new routes to their child. So that the
        // proper way to add some routes to the existing routes is that the
        // Vue router should be constructed flat design.
        this.$router.addRoute(rootRoutes)
        // router.options is the object passed to the vuerouter constructor.
        // It's not modified afterwards. So, right added new routes cannot
        // be shown by router.options.routes.
        // vue2 
        // router.options.routes.forEach(route => {
        //   console.log(JSON.stringify(route))
        // })
        // vue3 
        // Instead, getRoutes() should be used to get the right routes.
        // this.$router.getRoutes().forEach(route => {
        //   console.log(JSON.stringify(route))
        // }
        if (
          this.$route.path.startsWith('/service') &&
          this.$route.matched.length < 2
        ) {
          this.$router.replace(this.$route.fullPath)
        }
      })
    }
  }
}

// import { h }         from 'vue'
// import { RouterView } from 'vue-router'
// import __C           from '../primitives/_constant_'
// import { ServiceRoutes } from '../router/service'

// export default {
//   methods: {
//     setServiceRouter(navItems) {
//       console.log('navItems:', navItems)
//       ServiceRoutes(navItems, routes__ => {
//         // 1) 먼저 parent 루트를 찾고
//         const root = this.$router.getRoutes().find(r => r.path === '/')
//         // 2) serviceRoutes 정의
//         const serviceRoutes = {
//           path: 'service',
//           redirect: __C.APPLICATION.URL_HOME,
//           name: 'Application Service Page',
//           component: RouterView,    // ← RouterView로
//           children: routes__
//         }
//         // 3) addRoute로 '루트' 아래에 붙이기
//         if (root && root.name) {
//           // root.name: 'Jin Solution' (layout에서 정의한 값)
//           this.$router.addRoute(root.name, serviceRoutes)
//         } else {
//           this.$router.addRoute('/', serviceRoutes)
//         }
//       })
//     }
//   }
// }

